export enum TableCategory {
    INBOX = 'inbox',
    EN_ROUTE = 'en-route',
    FINISHED = 'finished',
    ARCHIVE = 'archive',
}
